import {
  EVENT_GET,
  EVENT_LOADING,
  EVENT_STREAMS,
  EVENT_REMOVE_STREAM_LOCAL,
  EVENT_UPDATE,
  EVENTS_DONATIONS_SET_ID,
  DONATIONS_LOADING
} from 'types/actions/event'
import { EVENT_GET_STATS } from 'types/actions/event'
import { EVENT_SET_DONATIONS } from 'types/actions/event'
import { EVENT_DONATIONS_PUSH } from 'types/actions/event'
import update from 'immutability-helper'
import { EVENT_DONATIONS_REMOVE } from 'types/actions/event'
import { EVENT_SET_CHATS } from 'types/actions/event'
import { EVENT_SET_CHAT_LOADING } from 'types/actions/event'
import { EVENT_PUSH_CHATS } from 'types/actions/event'
import { EVENT_TICKETS_SET } from 'types/actions/event'
import { EVENT_REMOVE_MESSAGE } from 'types/actions/event'
import { EVENT_TICKETS_LOADING } from 'types/actions/event'
import { MY_TICKETS_SET } from 'types/actions/event'
import { MY_TICKETS_LOADING } from 'types/actions/event'

const eventInitialState = {
  event: {
    live_settings: {}
  },
  donations: [],
  donationIds: {},
  loading: true,
  stats: {},
  chatsLoading: false,
  chats: [],
  eventTicketsLoading: true,
  tickets: [],
  myTicketsLoading: true,
  myTickets: [],
  donationsLoading: false
}

export default (state = eventInitialState, action) => {
  switch (action.type) {
    case DONATIONS_LOADING:
      return {
        ...state,
        donationsLoading: action.donationsLoading
      }
    case EVENT_GET:
      return {
        ...state,
        event: action.event
      }
    case EVENT_LOADING:
      return {
        ...state,
        loading: action.loading
      }
    case EVENT_STREAMS:
      return {
        ...state,
        event: { ...state.event, live_url_data: action.streams }
      }
    case EVENT_UPDATE:
      return {
        ...state,
        event: { ...state.event, ...action.event }
      }
    case EVENT_REMOVE_STREAM_LOCAL:
      return {
        ...state,
        event: {
          ...state.event,
          live_url_data: state.event.live_url_data.filter(
            x => x.id !== action.id
          )
        }
      }
    case EVENT_GET_STATS:
      return {
        ...state,
        stats: action.stats
      }
    case EVENTS_DONATIONS_SET_ID:
      const donationId = state.donationIds[action.donation.user_id]
      if (donationId) {
        return state
      } else {
        let last4 = action.donation.user_phone.slice(
          action.donation.user_phone.length - 4
        )
        const donationIdValues = Object.values(state.donationIds)
        const similarLast4 = donationIdValues
          .filter(x => x.toString().indexOf(last4) > -1)
          .map(x => parseInt(x, 10))
          .sort(function(a, b) {
            return b - a
          })
        if (similarLast4.length > 0) {
          if (similarLast4[0].toString().length === 4) {
            last4 = similarLast4[0].toString() + '1'
          } else {
            last4 = similarLast4[0] + 1
          }
        }
        return update(state, {
          donationIds: {
            [action.donation.user_id]: {
              $set: last4
            }
          }
        })
      }
    case EVENT_SET_DONATIONS:
      return {
        ...state,
        donations: action.donations
      }
    case EVENT_DONATIONS_PUSH:
      return update(state, {
        donations: {
          $push: [action.donation]
        }
      })
    case EVENT_DONATIONS_REMOVE:
      const arrayIndex = state.donations.findIndex(
        d => d.donation_id === action.donationId
      )
      return update(state, {
        donations: {
          $splice: [[arrayIndex, 1]]
        }
      })
    case EVENT_SET_CHATS:
      return update(state, {
        chats: {
          $set: action.chats
        }
      })
    case EVENT_SET_CHAT_LOADING:
      return update(state, {
        chatsLoading: {
          $set: action.chatsLoading
        }
      })
    case EVENT_PUSH_CHATS:
      return update(state, {
        chats: {
          $set: [...state.chats, ...action.chats]
        }
      })
    case EVENT_REMOVE_MESSAGE:
      return {
        ...state,
        chats: state.chats.filter(x => x.id !== action.id)
      }
    case EVENT_TICKETS_SET:
      return update(state, {
        tickets: {
          $set: action.tickets
        }
      })
    case EVENT_TICKETS_LOADING:
      return update(state, {
        eventTicketsLoading: {
          $set: action.eventTicketsLoading
        }
      })
    case MY_TICKETS_SET:
      return update(state, {
        myTickets: {
          $set: action.myTickets
        }
      })
    case MY_TICKETS_LOADING:
      return update(state, {
        myTicketsLoading: {
          $set: action.myTicketsLoading
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/event.js